import Connectors, { CONNECTOR_SUBTYPES, FILE_TYPES } from '../../../api/Connectors/Connectors';
import { MAPSERVERELEMENTS_TYPES } from '../../../api/MapServerElements/MapServerElements';
import * as sourceOps from '../../../api/Sources/source-operations';
import Sources from '../../../api/Sources/Sources';
import { NODE_TYPES, SUBTASK_PARAM_TYPES } from '../../../api/Tasks/taskConstants';

const replaceSource = sourceName => Sources.findOne({ name: sourceName }) || {};

const getSourceConnector = source => Connectors.findOne(sourceOps.getConnectorId(source)) || {};

const exampleIATaks = () => ({
  label: 'IANewFeatures',
  name: 'IA_New_Features',
  group: 'AI',
  links: [
    {
      source: 'AOI',
      target: 'newFeature'
    },
    {
      source: 'orthophoto',
      target: 'newFeature'
    },
    {
      source: 'LiDAR',
      target: 'newFeature'
    },
    {
      source: 'SentinelImage',
      target: 'newFeature'
    },
    {
      source: 'newFeature',
      target: 'outoputfile'
    }
  ],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'AOI',
      nodeLabel: 'Area of interest',
      argName: 'AOI',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [],
        allowedFileTypes: [FILE_TYPES.KML],
        allowedMapServerElementTypes: [],
        temporal: false,
        createMapServerElement: false,
        connector: getSourceConnector(replaceSource('AOI')),
        source: replaceSource('AOI')
      }
    },
    {
      x: 50,
      y: 150,
      id: 'orthophoto',
      nodeLabel: 'orthophoto to extract new features',
      argName: 'orthophoto',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [],
        allowedFileTypes: [FILE_TYPES.ECW, FILE_TYPES.GEOTIFF],
        allowedMapServerElementTypes: [],
        temporal: false,
        createMapServerElement: false,
        connector: getSourceConnector(replaceSource('Orto')),
        source: replaceSource('Orto')
      }
    },
    {
      x: 50,
      y: 250,
      id: 'LiDAR',
      nodeLabel: 'LiDAR to extract new features',
      argName: 'lidar',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [],
        allowedFileTypes: [FILE_TYPES.GEOTIFF],
        allowedMapServerElementTypes: [],
        temporal: false,
        createMapServerElement: false,
        connector: getSourceConnector(replaceSource('Lidar')),
        source: replaceSource('Lidar')
      }
    },
    {
      x: 50,
      y: 350,
      id: 'SentinelImage',
      nodeLabel: 'Sentinel Image to extract new features',
      argName: 'ms',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [],
        allowedFileTypes: [FILE_TYPES.GEOTIFF],
        allowedMapServerElementTypes: [],
        temporal: false,
        createMapServerElement: false,
        connector: getSourceConnector(replaceSource('Sentinel')),
        source: replaceSource('Sentinel')
      }
    },
    {
      x: 350,
      y: 200,
      id: 'outoputfile',
      nodeLabel: 'outoputfile',
      argName: 'outoputfile',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [],
        allowedFileTypes: [FILE_TYPES.SHAPE, FILE_TYPES.GEOTIFF],
        allowedMapServerElementTypes: [],
        temporal: false,
        createMapServerElement: false,
        connector: getSourceConnector(replaceSource('AI_output')),
        source: replaceSource('AI_output')
      }
    },
    {
      x: 200,
      y: 200,
      id: 'newFeature',
      nodeLabel: 'newFeature',
      nodeType: NODE_TYPES.SUBTASK,
      methodUrl: '/AI/skyNet/new_entities',
      argName: 'newFeature',
      paramList: [
        {
          id: 'indexes',
          label: 'origin_model',
          type: 'STRING',
          multiValue: true,
          options: ['edificios', 'piscinas'],
          value: ['edificios']
        }
      ]
    }
  ]
});

const exampleJoinTask = () => ({
  label: 'Join',
  name: 'join_layers',
  group: 'GMS/thematic',
  links: [
    {
      source: 'vectorLayer',
      target: 'join'
    },
    {
      source: 'thematicLayer',
      target: 'join'
    },
    {
      source: 'join',
      target: 'joinLayer'
    }
  ],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'vectorLayer',
      nodeLabel: 'Data Vector origin',
      argName: 'vector_layer',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [CONNECTOR_SUBTYPES.VECTOR],
        allowedFileTypes: [FILE_TYPES.SHAPE, FILE_TYPES.KML, FILE_TYPES.GEOJSON],
        allowedMapServerElementTypes: [],
        connector: getSourceConnector(replaceSource('A rEaL Source Vector Join')),
        source: replaceSource('A rEaL Source Vector Join'),
        temporal: false,
        createMapServerElement: false
      }
    },
    {
      x: 50,
      y: 250,
      id: 'thematicLayer',
      nodeLabel: 'Data thematic origin',
      argName: 'thematic_layer',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [CONNECTOR_SUBTYPES.THEMATIC],
        allowedFileTypes: [FILE_TYPES.CSV, FILE_TYPES.EXCEL],
        allowedMapServerElementTypes: [],
        connector: getSourceConnector(replaceSource('A rEaL Source Thematic')),
        source: replaceSource('A rEaL Source Thematic'),
        temporal: false,
        createMapServerElement: false
      }
    },
    {
      x: 500,
      y: 150,
      id: 'joinLayer',
      nodeLabel: 'output join layer',
      argName: 'output_layer',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [CONNECTOR_SUBTYPES.VECTOR],
        allowedFileTypes: [FILE_TYPES.SHAPE, FILE_TYPES.KML, FILE_TYPES.GEOJSON],
        allowedMapServerElementTypes: [
          MAPSERVERELEMENTS_TYPES.WMS,
          MAPSERVERELEMENTS_TYPES.TMS,
          MAPSERVERELEMENTS_TYPES.GEOJSON
        ],
        connector: getSourceConnector(replaceSource('A rEaL Source Join Salida')),
        source: replaceSource('A rEaL Source Join Salida'),
        temporal: false,
        createMapServerElement: true,
        mapServerElementType: MAPSERVERELEMENTS_TYPES.TMS,
        autorefresh: true
      }
    },
    {
      x: 250,
      y: 150,
      id: 'join',
      nodeLabel: 'join',
      nodeType: NODE_TYPES.SUBTASK,
      methodUrl: 'GMS/thematic/join',
      argName: 'join',
      paramList: [
        {
          id: 'vector_id',
          label: 'vector_id',
          type: SUBTASK_PARAM_TYPES.STRING,
          options: [],
          value: 'coddistrito'
        },
        {
          id: 'thematic_id',
          label: 'thematic_id',
          type: SUBTASK_PARAM_TYPES.STRING,
          options: [],
          value: 'coddistrito'
        },
        {
          id: 'type_join',
          label: 'thematic_id',
          type: SUBTASK_PARAM_TYPES.STRING,
          multiValue: false,
          options: ['innerjoin', 'leftjoin'],
          value: 'innerjoin'
        }
      ]
    }
  ]
});

const exampleMSETask = () => ({
  ready: true,
  label: 'Create MSE (Method1)',
  name: 'create_mse_1',
  group: 'Management',
  links: [],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'dataOriginManagement',
      nodeLabel: 'Data origin',
      argName: 'input_layer',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [CONNECTOR_SUBTYPES.VECTOR],
        allowedFileTypes: [
          FILE_TYPES.SHAPE,
          FILE_TYPES.KML,
          FILE_TYPES.GEOJSON,
          FILE_TYPES.GEOTIFF,
          FILE_TYPES.SENTINEL,
          FILE_TYPES.ECW,
          FILE_TYPES.CSV,
          FILE_TYPES.EXCEL,
          FILE_TYPES.LASS,
          FILE_TYPES.ZIP,
          FILE_TYPES.ZIP7,
          FILE_TYPES.MDB,
          FILE_TYPES.RAR
        ],
        allowedMapServerElementTypes: [
          MAPSERVERELEMENTS_TYPES.TMS,
          MAPSERVERELEMENTS_TYPES.WMS,
          MAPSERVERELEMENTS_TYPES.GEOJSON
        ],
        connector: getSourceConnector(replaceSource('Real Test Source MSE')),
        source: replaceSource('Real Test Source MSE'),
        temporal: false,
        createMapServerElement: true,
        mapServerElementType: MAPSERVERELEMENTS_TYPES.WMS,
        autorefresh: false,
        refreshLatency: 1
      }
    }
  ]
});

const wrongExample = () => ({
  label: 'Wrong Example',
  name: 'wrong_example',
  group: 'Management',
  links: [],
  nodes: [
    {
      x: 50,
      y: 50,
      id: 'dataOriginManagement',
      nodeLabel: 'Data origin',
      argName: 'input_layer',
      nodeType: NODE_TYPES.CONNECTION,
      connectionParams: {
        allowedPGTypes: [CONNECTOR_SUBTYPES.VECTOR],
        allowedFileTypes: [
          FILE_TYPES.SHAPE,
          FILE_TYPES.KML,
          FILE_TYPES.GEOJSON,
          FILE_TYPES.GEOTIFF,
          FILE_TYPES.SENTINEL,
          FILE_TYPES.ECW,
          FILE_TYPES.CSV,
          FILE_TYPES.EXCEL,
          FILE_TYPES.LASS,
          FILE_TYPES.ZIP,
          FILE_TYPES.ZIP7,
          FILE_TYPES.MDB,
          FILE_TYPES.RAR
        ],
        allowedMapServerElementTypes: [
          MAPSERVERELEMENTS_TYPES.TMS,
          MAPSERVERELEMENTS_TYPES.WMS,
          MAPSERVERELEMENTS_TYPES.GEOJSON
        ],
        connector: getSourceConnector(replaceSource('Source GeoJSON')),
        source: replaceSource('Source GeoJSON'),
        temporal: false,
        createMapServerElement: true,
        mapServerElementType: MAPSERVERELEMENTS_TYPES.WMS,
        autorefresh: false,
        refreshLatency: 1
      }
    }
  ]
});

const exampleGeneralizationTask = () => ({
  ready: true,
  label: 'Generalization',
  name: 'Generalization_Tierra2',
  group: 'Tierra2/GMS/vectorial',
  links: [
    {
      source: 'g_originalVectorLayer',
      target: 'g_clean'
    },
    {
      source: 'g_clean',
      target: 'g_cleanedVectorLayer'
    },
    {
      source: 'g_cleanedVectorLayer',
      target: 'g_dissolve'
    },
    {
      source: 'g_dissolve',
      target: 'g_disolvedVectorLayer'
    },
    {
      source: 'g_disolvedVectorLayer',
      target: 'g_simplify'
    },
    {
      source: 'g_simplify',
      target: 'g_simplifiedVectorLayer'
    }
  ],
  nodes: [
    {
      connectionParams: {
        allowedPGTypes: ['VECTOR'],
        createMapServerElement: false,
        allowedFileTypes: [],
        source: {
          owner: 'u6XvYbDyZefZWH8Hg',
          name: 'map_dis',
          connectorId: 'ZvCokpKuxSDJmZTrz',
          updatedAt: '2019-10-16T06:37:21.795Z',
          type: 'VECTOR',
          tableViewName: 'map_dis',
          _id: 'NSpxJie9hZvjqszjY',
          createdAt: '2019-10-16T06:37:21.794Z',
          deleted: 'no'
        },
        allowedMapServerElementTypes: [],
        temporal: false,
        connector: {
          createdAt: '2019-10-16T06:37:21.792Z',
          databaseName: 'Prueba_tierra2',
          ip: '192.168.1.52',
          schema: 'public',
          password: 'pg',
          user: 'postgres',
          owner: 'u6XvYbDyZefZWH8Hg',
          type: 'PostgreSQL',
          name: 'PG_Pruebas',
          port: 5433,
          updatedAt: '2019-10-16T06:37:21.792Z',
          _id: 'ZvCokpKuxSDJmZTrz',
          deleted: 'no'
        }
      },
      x: 50,
      argName: 'input_layer',
      startedAt: '2019-10-16T06:37:21.994673',
      status: 'PAUSED',
      id: 'g_originalVectorLayer',
      nodeLabel: 'original Vector Layer',
      nodeType: 'CONNECTION',
      y: 50,
      progress: 0
    },
    {
      x: 150,
      argName: 'clean',
      status: 'PAUSED',
      id: 'g_clean',
      nodeLabel: 'clean',
      nodeType: 'SUBTASK',
      progress: 0,
      paramList: [
        {
          id: 'tolerance',
          options: [],
          type: 'NUMBER',
          label: 'tolerance',
          value: '0.0001',
          required: true
        },
        { type: 'STRING', options: [], id: 'sql_filter', required: false, label: 'sql_filter' }
      ],
      methodUrl: '/GMS/vectorialTierra2/clean',
      y: 50
    },
    {
      connectionParams: {
        allowedPGTypes: ['VECTOR'],
        createMapServerElement: false,
        allowedFileTypes: [],
        source: {
          createdAt: '2019-10-16T06:37:21.794Z',
          updatedAt: '2019-10-16T06:37:21.795Z',
          _id: 'temporal',
          deleted: 'no'
        },
        allowedMapServerElementTypes: ['TMS', 'WMS', 'GeoJSON'],
        temporal: true,
        connector: {
          createdAt: '2019-10-16T06:37:21.792Z',
          updatedAt: '2019-10-16T06:37:21.792Z',
          _id: 'temporal',
          deleted: 'no'
        }
      },
      x: 250,
      argName: 'input_layer',
      status: 'PAUSED',
      id: 'g_cleanedVectorLayer',
      nodeLabel: 'cleaned Vector Layer',
      nodeType: 'CONNECTION',
      y: 50,
      progress: 0
    },
    {
      x: 350,
      argName: 'dissolve',
      status: 'PAUSED',
      id: 'g_dissolve',
      nodeLabel: 'dissolve',
      nodeType: 'SUBTASK',
      progress: 0,
      paramList: [
        {
          id: 'common_field',
          options: [],
          type: 'STRING',
          label: 'common Field',
          value: 'fusions',
          required: true
        },
        { type: 'STRING', options: [], id: 'sum_field', required: false, label: 'sumField' },
        { type: 'STRING', options: [], id: 'avg_field', required: false, label: 'avgField' },
        { type: 'STRING', options: [], id: 'max_field', required: false, label: 'maxField' },
        { type: 'STRING', options: [], id: 'min_field', required: false, label: 'minField' },
        {
          id: 'force_simple_geom',
          options: [],
          type: 'BOOLEAN',
          label: 'simpleGeometry',
          value: 'false',
          required: false
        }
      ],
      methodUrl: '/GMS/vectorialTierra2/dissolve',
      y: 50
    },
    {
      connectionParams: {
        allowedPGTypes: ['VECTOR'],
        createMapServerElement: false,
        allowedFileTypes: [],
        source: {
          createdAt: '2019-10-16T06:37:21.794Z',
          updatedAt: '2019-10-16T06:37:21.795Z',
          _id: 'temporal',
          deleted: 'no'
        },
        allowedMapServerElementTypes: [],
        temporal: true,
        connector: {
          createdAt: '2019-10-16T06:37:21.792Z',
          updatedAt: '2019-10-16T06:37:21.793Z',
          _id: 'temporal',
          deleted: 'no'
        }
      },
      x: 450,
      argName: 'input_layer',
      status: 'PAUSED',
      id: 'g_disolvedVectorLayer',
      nodeLabel: 'disolved Vector Layer',
      nodeType: 'CONNECTION',
      y: 50,
      progress: 0
    },
    {
      x: 550,
      argName: 'simplify',
      status: 'PAUSED',
      id: 'g_simplify',
      nodeLabel: 'simplify',
      nodeType: 'SUBTASK',
      progress: 0,
      paramList: [
        {
          id: 'tolerance',
          options: [],
          type: 'NUMBER',
          label: 'tolerance',
          value: '0.0001',
          required: true
        },
        {
          id: 'topo_ignore',
          options: [],
          type: 'BOOLEAN',
          label: 'topology Ignore',
          value: 'false',
          required: true
        }
      ],
      methodUrl: '/GMS/vectorialTierra2/simplify',
      y: 50
    },
    {
      connectionParams: {
        allowedPGTypes: ['VECTOR'],
        mapServerElementType: 'GeoJSON',
        createMapServerElement: true,
        allowedFileTypes: [],
        source: {
          owner: 'u6XvYbDyZefZWH8Hg',
          name: 'map_dis_generalizada',
          connectorId: 'ZvCokpKuxSDJmZTrz',
          updatedAt: '2019-10-16T06:37:21.795Z',
          type: 'VECTOR',
          tableViewName: 'map_dis_generalizada',
          _id: 'o9AHvza3jSQRnWC3Y',
          createdAt: '2019-10-16T06:37:21.794Z',
          deleted: 'no'
        },
        allowedMapServerElementTypes: ['WMS', 'TMS', 'GeoJSON'],
        temporal: false,
        connector: {
          createdAt: '2019-10-16T06:37:21.792Z',
          databaseName: 'Prueba_tierra2',
          ip: '192.168.1.52',
          schema: 'public',
          password: 'pg',
          user: 'postgres',
          owner: 'u6XvYbDyZefZWH8Hg',
          type: 'PostgreSQL',
          name: 'PG_Pruebas',
          port: 5433,
          updatedAt: '2019-10-16T06:37:21.792Z',
          _id: 'ZvCokpKuxSDJmZTrz',
          deleted: 'no'
        },
        autorefresh: true
      },
      x: 650,
      argName: 'simplified_Vector_Layer',
      status: 'PAUSED',
      id: 'g_simplifiedVectorLayer',
      nodeLabel: 'simplified Vector Layer',
      nodeType: 'CONNECTION',
      y: 50,
      progress: 0
    }
  ]
});

export default () => [
  exampleMSETask(),
  exampleJoinTask(),
  exampleIATaks(),
  wrongExample(),
  exampleGeneralizationTask()
];
